<script>
import TwFileUpload from '../TwFileUpload';
import fileTypes from '../../variables/fileTypes';
import NonDynamicTransportContractTable from './NonDynamicTransportContractTable';

export default {
  name: 'NonDynamicTransportUpload',
  components: {
    TwFileUpload,
    NonDynamicTransportContractTable,
  },
  props: {
    contracts: {
      type: Array,
      default: () => [],
    },
    transportId: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUploadModal: false,
      fileTypes,
    };
  },
  methods: {
    upload(event) {
      this.$emit('upload', event);
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="showUploadModal"
    width="700"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="!transportId"
        color="primary lighten-2"
        v-on="on"
      >
        <v-icon dark left>backup</v-icon>{{ $t('buttons.uploadContract') }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        {{ $t('nonDynamicTransport.labels.contracts') }}
      </v-card-title>

      <tw-file-upload
        :file-type="fileTypes.DOC"
        :loading="loading"
        @upload="upload"
      />

      <v-divider class="mt-2"/>

      <non-dynamic-transport-contract-table
        :transport-id="transportId"
        :contracts="contracts"
      />

      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="showUploadModal = false"
        >
          {{ $t('buttons.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportUpload.vue